import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const HeroSectionComponent = ({
    title,
    subtitle,
    buttonText,
    onButtonClick,
    imageSrc,
    imageAlt = 'Hero Image',
    showButton = true
  }) => {
  
  const theme = useTheme();
  const { t } = useTranslation('landing');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Use provided props or fallback to translations
  const displayTitle = title || t('hero.title');
  const displaySubtitle = subtitle || t('hero.subtitle');
  const displayButtonText = buttonText || t('hero.buttonText');

  return (
    <Box
      sx={{
        py: 8,
        background: 'linear-gradient(to right, #f5f7fa, #c3cfe2)',
        position: 'relative'
      }}
    >
      <Container>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            {/* Desktop Title */}
            <Typography
              component="h1"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontSize: { xs: '2.5rem', sm: '4rem' },
                lineHeight: 1.2,
                mb: { xs: 2, sm: 0 }
              }}
            >
              {isMobile
                ? displayTitle.replace(/\n/g, ' ')
                : displayTitle.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < displayTitle.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
            </Typography>

            {/* Subtitle */}
            <Typography variant="h5" color="text.secondary" paragraph>
              {displaySubtitle}
            </Typography>

            {/* CTA Button */}
            {showButton && (
            <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
                <Button
                onClick={onButtonClick}
                variant="contained"
                color="primary"
                size="large"
                endIcon={<KeyboardArrowRightIcon />}
                >
                {displayButtonText}
                </Button>
            </Box>
            )}
          </Grid>

          {/* Hero Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: 400,
                borderRadius: 4,
                overflow: 'hidden',
                boxShadow: 10
              }}
            >
              <img
                src={imageSrc}
                alt={imageAlt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSectionComponent;